import { XMarkIcon } from '@heroicons/react/16/solid';
import { DocumentIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import truncateString from 'src/shared/utils/truncateString';

import { Typography } from '../ui';
import { ButtonV2 } from '../ui';

interface FileAttachmentProps {
  file?: File;
  fileUrl?: string;
  fileName?: string;
  onRemove?: () => void;
  description?: string;
}

const FileAttachment: React.FC<FileAttachmentProps> = ({
  file,
  onRemove,
  fileName,
  fileUrl,
  description
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative max-w-fit"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <ButtonV2
        onPress={() => {
          if (fileUrl) {
            window.open(fileUrl, '_blank');
          }
        }}
        className="p-1 pr-2 relative hover:bg-white min-w-36 justify-start"
        startContent={
          <div className="bg-gray-2 size-10 flex items-center justify-center rounded-xl">
            <DocumentIcon className="size-5 text-primary" />
          </div>
        }
        size="xl"
        color="tertiary"
      >
        <div className="flex flex-col items-start">
          <Typography variant="body-2" weight="medium">
            {fileName ?? file?.name ?? ''}
          </Typography>
          {description && (
            <Typography
              variant="body-3"
              weight="medium"
              className="text-secondary-text text-left"
            >
              {truncateString(description, 30)}
            </Typography>
          )}
        </div>
      </ButtonV2>

      {isHovered && onRemove && (
        <ButtonV2
          onPress={onRemove}
          size="xs"
          className="bg-black absolute -right-2 -top-2 w-5"
          isIconOnly
        >
          <XMarkIcon className="size-4 text-white" />
        </ButtonV2>
      )}
    </div>
  );
};

export default FileAttachment;
